// Supabase 客户端配置（仅浏览器 anon key）
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/database';
import { resolveSupabaseUrl } from './supabaseUrl';

export { resolveSupabaseUrl } from './supabaseUrl';
export type { ResolveSupabaseUrlOptions } from './supabaseUrl';

const configuredUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;
const authStorageKey = (import.meta.env.VITE_AUTH_STORAGE_KEY as string) || 'ubus-auth-token';

const supabaseUrl = resolveSupabaseUrl(configuredUrl);

if (!supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY. Please check .env.local / .env.production.');
}

if (!supabaseUrl) {
  if (typeof window === 'undefined') {
    throw new Error('Missing Supabase URL. Set VITE_SUPABASE_URL or run in browser with SAME_ORIGIN.');
  }
  throw new Error('Unable to resolve Supabase URL from window.location.origin.');
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      storageKey: authStorageKey,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      autoRefreshToken: true,
      detectSessionInUrl: true
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  }
);

export type { SupabaseClient } from '@supabase/supabase-js';
export type { Database } from '../types/database';
